import React from 'react';

type Props = {
  href: string;
  children: React.ReactNode;
  rel?: string;
  target?: string;
};

const Link = ({ children, href, rel, target }: Props) => {
  const handleClick = () => {
    window.open(href, '_blank', 'noopener,noreferrer');
  };

  return (
    <a href={href} onClick={handleClick} rel={rel} target={target}>
      {children}
    </a>
  );
};

export default Link;
